import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { CalendarModule } from 'angular-calendar';
import { DirectivesModule } from '../../theme/directives/directives.module';
import { ClientParentComponent } from './client-parent.component';
import { ClientParentRoutingModule } from './client-parent-routing.module';
import { MaskedTextBoxModule } from '@syncfusion/ej2-angular-inputs';
import { NgSelectModule } from '@ng-select/ng-select';
import { NgxUiLoaderModule } from 'ngx-ui-loader';
import { ClientCreateEditComponent } from './client-create-edit/client-create-edit.component';
import { ClientListComponent } from './client-list/client-list.component';
import { ColumnChooserService, FilterService, GridModule, PageService, ReorderService, ResizeService, SortService } from '@syncfusion/ej2-angular-grids';
import { MyDatePickerModule } from 'mydatepicker';
import { ClientEmployeeContactModule } from '../client-employee-contact/client-employee-contact.module';
import { clientOnboardingListModule } from '../client-onboardinglist/client-onboardinglist.module';
import { clienttserivce } from './clienttservice';
import { clienttserivcetax } from './clientttaxservice';
import { ClientEmployeeRelationshipModule } from '../client-employee-relationship/client-employee-relationship.module';
import { ClientAuthorizationComponent } from './client-authorization/client-authorization.component';
import { BudgetimportModule } from '../budgetimport/budgetimport.module';
import { BudgetplanFormModule } from '../budgetplan-form/budgetplan-form.module';
import { PurchaseRequestModule } from '../purchase-request/purchase-request.module';
import { ClientNotesModule } from '../client-notes/client-notes.module';
import { ClientAuthorizationEditComponent } from './client-authorization-edit/client-authorization-edit.component';
import { ClientEmployeeDynamicFormModule } from '../client-employee-dynamicform/client-employee-dynamicform.module';
import { ConsultationServicesRoutingModule } from '../consultation-services/consultation-services-routing.module';
import { ConsultationServicesModule } from '../consultation-services/consultation-services.module';
import { ClientEmployeeDocumentModule } from '../client-employee-document/client-employee-document.module';
import { ServiceplanModule } from '../serviceplan/serviceplan.module';
import { ClientMonitorlistModule } from '../client-monitorlist/client-monitorlist.module';
import { DischargeCodesModule } from '../discharge-codes/discharge-codes.module';
import { StartofcareeditComponent } from './startofcareedit/startofcareedit.component';
import { StartofcarelistComponent } from './startofcarelist/startofcarelist.component';
import { dropdownModule } from "../../dropdown/dropdown.module";
import { TooltipModule } from '@syncfusion/ej2-angular-popups';
import { PDFExportModule } from '@progress/kendo-angular-pdf-export';
import { AutoCompleteModule, DropDownListAllModule, ListBoxAllModule } from '@syncfusion/ej2-angular-dropdowns';
import { NgbModule, NgbPopoverModule } from '@ng-bootstrap/ng-bootstrap';
import { DragDropModule } from '@angular/cdk/drag-drop';
import { AccordionModule } from '@syncfusion/ej2-angular-navigations';
import { SignaturePadModule } from 'angular2-signaturepad';
import { PdfViewerModule } from 'ng2-pdf-viewer';
import { NgMultiSelectDropDownModule } from 'ng-multiselect-dropdown';


import { ImportPaymentModule } from '../import-payment/import-payment.module';import { CaseManagerModule } from '../case-manager/case-manager.module';
import { CareCoordinatorModule } from '../care-coordinator/care-coordinator.module';
import { ClientCertificateEditComponent } from './client-certificate-edit/client-certificate-edit.component';
import { ClientCertificateListComponent } from './client-certificate-list/client-certificate-list.component';
import { PhysicianComponent } from './physician/physician.component';
import { ICD10Module } from '../icd10/icd10.module';
import { Eligibility270Module } from '../eligibility270/eligibility270.module';
import { EligibilityDetailsComponent } from './eligibility-details/eligibility-details.component';
import { EligibilityDifferenceReportComponent } from './eligibility-difference-report/eligibility-difference-report.component';
import { EligibilityReportComponent } from './eligibility-report/eligibility-report.component';
import { GoogleMapModule } from '../google-map/google-map.module';

import { ClientAuthorizationReportComponent } from './client-authorization-report/client-authorization-report.component';
import { FmsAgencyModule } from '../fms-agency/fms-agency.module';
import { HomeHealthAgencyModule } from '../home-health-agency/home-health-agency.module';
import { EngagementModule } from '../engagement/engagement.module';
import { InboxModule } from '../inbox/inbox.module';
import { TicketModule } from '../ticket/ticket.module';
import { QpInfoModule } from '../qp-info/qp-info.module';
@NgModule({
  exports:[ClientAuthorizationEditComponent,
    StartofcareeditComponent,
    ClientCertificateEditComponent
  ],
  imports: [
    CommonModule,
    FormsModule,
    CalendarModule,
    DirectivesModule,
    ClientParentRoutingModule,
    MaskedTextBoxModule,
    GridModule,
    NgSelectModule,
    MyDatePickerModule,
    ClientEmployeeContactModule,
    clientOnboardingListModule,
    ClientEmployeeRelationshipModule,
    BudgetimportModule,
    BudgetplanFormModule,
    PurchaseRequestModule,
    ClientNotesModule,
    ClientEmployeeDynamicFormModule,
    ConsultationServicesModule,
    ClientEmployeeDocumentModule,
    ServiceplanModule,
    ClientMonitorlistModule,
    ICD10Module,
    CaseManagerModule,
    CareCoordinatorModule,
    DischargeCodesModule,
    dropdownModule,
    TooltipModule,
    PDFExportModule,
    DropDownListAllModule,
    NgbModule,
    ListBoxAllModule,
    DragDropModule,
    AccordionModule,
    SignaturePadModule,
    AutoCompleteModule,
    AutoCompleteModule,
    FormsModule,
    NgMultiSelectDropDownModule.forRoot(),
    PdfViewerModule,
    NgbPopoverModule,
    ReactiveFormsModule.withConfig({ warnOnNgModelWithFormControl: 'never' }),
    NgxUiLoaderModule,
    GoogleMapModule,
    FmsAgencyModule,
    HomeHealthAgencyModule,
    EngagementModule,
    InboxModule,
    TicketModule,
    QpInfoModule


],
  declarations: [
    ClientParentComponent,
    ClientCreateEditComponent,
    ClientListComponent,
    ClientAuthorizationComponent,
    ClientAuthorizationEditComponent,
    StartofcareeditComponent,
    StartofcarelistComponent,
    ClientCertificateEditComponent,
    ClientCertificateListComponent,
    PhysicianComponent,
    EligibilityDetailsComponent,
    EligibilityDifferenceReportComponent,
    EligibilityReportComponent,
    ClientAuthorizationReportComponent,
    
  ],
  
  providers: [clienttserivcetax, clienttserivce, ColumnChooserService, PageService, SortService, FilterService, ResizeService,ReorderService],

})

export class ClientParentModule { }
